export default "__VITE_ASSET__BxI18zqe__"